import GenericSkeleton from 'components/skeleton/GenericSkeleton';
import TicketEntry from 'components/ticket/weekly-draw/TicketEntry';
import { useIsMobile } from 'hooks/ui/useIsMobile';
import { useEffect, useState } from 'react';
import { IEntryLine } from 'types/Draws';
import Chevron from '../../svg/ChevronLeft15.svg';
import { LOADING_TIMEOUT } from '../common/constants';
import styles from './TicketStack.module.css';

interface ITicketStackProps {
  entries: IEntryLine[];
  /** Whether to show a loading skeleton whilst the image loads in */
  withLoadingSkeleton?: boolean;
  /** Whether to be expanded or not. Changing this prop updates whether the
   * tickets are expanded or not
   */
  expanded?: boolean;
  hideExpandButton?: boolean;
}

const TicketStack = ({
  entries,
  withLoadingSkeleton,
  expanded: expandedProp,
  hideExpandButton,
}: ITicketStackProps) => {
  const { isMobile } = useIsMobile();
  const [expanded, setExpanded] = useState(!!expandedProp);
  const [ticketImageLoaded, setTicketImageLoaded] = useState(
    (withLoadingSkeleton ?? true) ? false : true,
  );
  useEffect(() => {
    setExpanded(!!expandedProp);
  }, [expandedProp]);

  const imageLoaded = (i: number) => {
    if (i === 0) {
      setTimeout(() => {
        setTicketImageLoaded(true);
      }, LOADING_TIMEOUT + 500);
    }
  };

  return (
    <>
      {!ticketImageLoaded && (
        <div className={styles.skeletonContainer}>
          <div className={styles.skeletonWrapper}>
            <GenericSkeleton
              inverseColors
              height={isMobile ? 130 : 180}
              borderRadius={18}
            />
          </div>
        </div>
      )}
      <div
        className={`${styles.container} ${ticketImageLoaded ? styles.ticketLoaded : ''}`}
        style={
          {
            '--ticketStack__offset': expanded ? '-8%' : '-27%',
          } as React.CSSProperties
        }
      >
        {entries.map((entry, i) => (
          <div
            key={i}
            className={styles.ticketWrapper}
            style={{ zIndex: entries.length - i }}
          >
            <TicketEntry entry={entry} imageLoaded={() => imageLoaded(i)} />
          </div>
        ))}

        {!hideExpandButton && entries.length > 1 && (
          <button
            className={`${styles.chevronButton} ${expanded ? styles.chevronButtonRotated : ''}`}
            onClick={() => setExpanded(!expanded)}
          >
            <span className={styles.chevron}>
              <Chevron />
            </span>
          </button>
        )}
      </div>
    </>
  );
};

export default TicketStack;
